//Import libraries
import { Box, CssBaseline, Grid } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
  useLocation,
} from "react-router-dom";
import * as XLSX from "xlsx";
//Import pages and components
import DashboardPage from "./pages/Dashboard";
import Error404 from "./pages/Error404";
import SignIn from "./pages/SignIn";
// import SignUp from './pages/SignUp'
// import ForgotPassword from './pages/ForgotPassword'
// import Homepage from './pages/Homepage'
// import Role from './pages/Role'
// import AddRole from './pages/AddRole'
import Profile from "./pages/Profile";
import Users from "./pages/Users";
// import UserPermissions from './pages/UserPermissions'
import CSVUpload from "./pages/CSVUpload";
import CreateEditTask from "./pages/CreateEditTask";
import EnhancedSchools from "./pages/EnhancedSchools";
import Organization from "./pages/Organization";
// import TaskModerationOverview from './pages/TaskModerationOverview'
// import Translations from './pages/Translations'
// import TranslateTasks from './pages/TranslateTasks'
// import ModerateTask from './pages/ModerateTasks'
import AddCollection from "./pages/AddCollection";
import ConfigureTeamCompetitionMembers from "./pages/ConfigureTeamCompetitionMembers";
import EditCollection from "./pages/EditCollection";
import UploadStudentAnswer from "./pages/UploadStudentAsnwer";
import UploadTeamCompetitionStudentAnswer from "./pages/UploadTeamCompetitionStudentAsnwer";
// import AddTaskToCollection from './pages/AddTaskToCollection'
import AddCompetition from "./pages/AddCompetition";
import CompetitionDetails from "./pages/CompetitionDetails";
import Competitions from "./pages/Competitions";
import ConfigureTeamCompetition from "./pages/ConfigureTeamCompetition";
import DifficultyGroup from "./pages/DifficultyGroup";
import EditCompetition from "./pages/EditCompetition";
import EditRoundMarking from "./pages/EditRoundMarking";
import GeneralAnswers from "./pages/GeneralAnswers";
import IdentifyUniqueAnswers from "./pages/IdentifyUniqueAnswers";
import MarkingOverview from "./pages/MarkingOverview";
import MarkingPreparation from "./pages/MarkingPreparation";
import TeamCompetitions from "./pages/TeamCompetitions";
// import PendingCompetitionPartners from './pages/PendingCompetitionPartners'
import Copyright from "./components/Copyright";
import NavBar from "./components/NavBar";
import SideBar from "./components/SideBar";
import ReusableButton from "./components/general/ReusableButton";
import ReusableDatePicker from "./components/general/ReusableDatePicker";
import AssignDifficulty from "./pages/AssignDifficulty";
//Import CSS
import "./css/global.css";
//Import redux stuff
import { useDispatch, useSelector } from "react-redux";
import {
  setCountryOptions,
  setLanguageOptions,
  setRoleOptions,
} from "./actions";
//Import functions
import {
  isAdmin,
  isAdminOrPartner,
  isAdminOrPartnerOrAssistant,
  isAdminOrPartnerOrAssistantOrManager,
  isAssistant,
  isLoggedIn,
  isTeacher,
} from "./functions/checkrole";
import { getCountries, getLanguages, getRoles } from "./functions/getData";
import AwardStats from "./pages/AwardsStats";
import CheatingList from "./pages/CheatingList";
import CollectionsModeration from "./pages/CollectionsModeration";
import Comp from "./pages/Comp";
import CompCollections from "./pages/CompCollections";
import Indvedual from "./pages/Indvidual";
import ModerateTeamBasedCompetitions from "./pages/ModerateTeamBasedCompetition";
import TasksModeration from "./pages/TasksModeration";
import VerfiyAssign from "./pages/VerfiyAssign";
import EditParticpantsBulk from "./pages/editParticpantsBulk";

import AssignTranslation from "./pages/AssignTranslation";
import AwardsCertiria from "./pages/AwardsCertiria";
import ChampionsPage from "./pages/ChampionsPage";
import ConfigureCertificate from "./pages/ConfigureCertificate";
import DownloadContestPaper from "./pages/DownloadContestPaper";
import EnhancedCollection from "./pages/EnhancedCollection";
import EnhancedCompReport from "./pages/EnhancedCompReport";
import EnhancedDomain from "./pages/EnhancedDomain";
import EnhancedParticipants from "./pages/EnhancedParticipants";
import EnhancedTasks from "./pages/EnhancedTasks";
import PrintCertificate from "./pages/PrintCertificate";
import TeamBasedMembers from "./pages/TeamBasedMembers";
import TeamBasedStudents from "./pages/TeamBasedStudents";
import TranslationModulePlaceholder from "./pages/TranslationModulePlaceholder";
import UploadedParticipantsFiles from "./pages/UploadedParticipantsFiles";

const EveryLink = ({ path, content, exact, defaultContent, condition }) => {
  let whatToShow;
  if (isLoggedIn()) {
    if (defaultContent) whatToShow = defaultContent;
    else {
      if (condition) whatToShow = content;
      else whatToShow = "Not allowed";
    }
  } else {
    if (defaultContent) whatToShow = content;
    else whatToShow = <Redirect to="/signin" />;
  }
  return (
    <Route path={path} exact={exact}>
      {whatToShow}
    </Route>
  );
};
const LegacyDashboard = () => {
  const [pageNo, setPageNo] = useState(0);
  const [csvFile, setCSVFile] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);
  const [isRange, setIsRange] = useState(false);
  const [dates, setDates] = useState([
    new Date().setHours(0, 0, 0, 0),
    new Date(new Date().setDate(new Date().getDate() + 7)).setHours(0, 0, 0, 0),
  ]);
  document.title = "Dashboard";
  const divStyle = (color) => ({
    border: `1px solid ${color}`,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginBottom: 10,
  });
  const openFileInput = () =>
    document.getElementById("file-upload-for-csv-xlsx").click();
  const onChangeCSVFile = (e, file) => {
    e.target.value = null;
    const reader = new FileReader();
    if (file.type === "text/csv") {
      setCSVFile(file);
      try {
        reader.onload = (e) => {
          const text = e.target.result;
          processCSV(text, ",", file.type);
        };
        reader.readAsText(file);
      } catch (err) {
        console.log(err.message);
      }
    } else if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setCSVFile(file);
      try {
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e) => {
          // e = on_file_select event
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const text = XLSX.utils.sheet_to_csv(ws, { header: 1 });
          /* Update state */
          processCSV(text, ",", file.type);
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
      } catch (err) {
        console.log(err.message);
      }
    } else {
      alert("FUCKOFF");
    }
  };
  const processCSV = (str, delim = ",", type) => {
    //Get the header from the large chunk of string read from the csv file
    const header = str
      .slice(0, str.indexOf("\n"))
      .trim()
      .replace(/['"]+/g, "")
      .split(delim);
    setHeaders(header);
    //Get all the data from the large chunk of string read from the csv file as an array
    const rows =
      type === "text/csv"
        ? str
            .slice(str.indexOf("\n") + 1)
            .split("\n")
            .slice(0, -1)
        : str.slice(str.indexOf("\n") + 1).split("\n");
    // let isSameColumns = [... new Set(rows.map(r => r.split(',').length).slice(0,-1))].length === 1
    // console.log(rows)
    const newArray = rows.map((row, index) => {
      const values = row.split(",");
      if (index < 10) {
      }
      // const values = delimitCSVRow(row)
      const eachObject = header.reduce((obj, header, i) => {
        //This function will return an array with the last item being an object with undefined values
        //So we check if the object is undefined before using string functions on the object
        obj[header] = values[i]
          ? values[i].trim().replace(/["]+/g, "")
          : values[i];
        return obj;
      }, {});
      return eachObject;
    });
    //We do not want to set the last item as the csvArray since the last item is just undefined
    //as we are setting the rows by checking if there is a next row
    const a = newArray;
    setData(a);
  };
  const tdStyle = { border: "1px solid" };

  return (
    <Grid container justifyContent="center" style={{ border: "1px solid red" }}>
      <div style={divStyle("red")}>
        <h2>Welcome to SIMCC</h2>
      </div>
      <div
        style={{
          width: "100%",
          display: window.location.host.includes("simcc") ? "none" : "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={divStyle("green")}>
          <button onClick={() => setIsRange(!isRange)}>
            Set mode to {isRange ? "normal" : "range"}
          </button>
          <ReusableDatePicker
            width={210}
            state={dates}
            multiple
            required
            range={isRange}
            setState={setDates}
            allowEmpty
          />
        </div>
        <ReusableButton
          text="Select File"
          bgColor="#144A94"
          fontSize={16}
          height={59}
          width={160}
          iconType="file"
          onClick={() => openFileInput()}
        />
        File Select:{csvFile ? ` ${csvFile.name}` : ""}
        <input
          id="file-upload-for-csv-xlsx"
          type="file"
          accept=".csv, .xlsx"
          onChange={(e) => onChangeCSVFile(e, e.target.files[0])}
          style={{ display: "none" }}
        />
        <table
          style={{
            display: "block",
            overflowY: "hidden",
            overflowX: "auto",
            whiteSpace: "nowrap",
            width: 1200,
            border: "1px solid",
          }}
        >
          <tbody>
            <tr>
              {headers.map((h) => (
                <th key={h} style={tdStyle}>
                  {h}
                </th>
              ))}
            </tr>
            {data.slice(pageNo * 20, pageNo * 20 + 20).map((d, i) => (
              <tr key={i}>
                {Object.values(d).map((v, i2) => (
                  <td key={`${i}-${i2}`} style={tdStyle}>
                    {v}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <Grid container>
          {data.length &&
            [...Array(Math.ceil(data.length / 20)).keys()].map((a, i) => (
              <div
                key={i}
                style={{
                  backgroundColor: pageNo === i ? "blue" : "white",
                  color: pageNo === i ? "white" : "black",
                  borderRadius: "50%",
                  height: 24,
                  width: 24,
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onClick={() => setPageNo(i)}
              >
                {i + 1}
              </div>
            ))}
        </Grid>
      </div>
    </Grid>
  );
};
const BodyContent = ({ open, toggleDrawer, hoverDrawer, unhoverDrawer }) => {
  const [partcipient, setPartcipient] = useState();
  const location = useLocation();
  const isDashboardRoute =
    location.pathname === "/dashboard" || location.pathname === "/";
  const defaultContent = <Redirect to="/dashboard" />;
  const routes = [
    // { path: "/", content: <EnhancedSchools />, exact: true },
    { path: "/", content: <DashboardPage />, exact: true },
    { path: "/signin", content: <SignIn />, defaultContent },
    // { path: '/signup', content: <SignUp />, defaultContent },
    // { path: '/forgotpassword', content: <ForgotPassword />, defaultContent },
    { path: "/dashboard", content: <DashboardPage /> },
    { path: "/schools", content: <EnhancedSchools /> },
    {
      path: "/participants",
      content: <EnhancedParticipants setPartcipient={setPartcipient} />,
    },
    { path: "/csvupload", content: <CSVUpload /> },
    { path: "/profile", content: <Profile /> },
    {
      path: "/users",
      content: <Users />,
      condition: isAdminOrPartnerOrAssistantOrManager(),
    },
    // { path: '/userpermissions/:id', content: <UserPermissions /> },
    {
      path: "/collection",
      content: <EnhancedCollection />,
      condition: isAdmin(),
    },
    {
      path: "/addcollection",
      content: <AddCollection />,
      condition: isAdmin(),
    },
    {
      path: "/editcollection",
      content: <EditCollection />,
      condition: isAdmin(),
    },
    { path: "/organizations", content: <Organization />, condition: isAdmin() },
    // { path: '/role', content: <Role />, condition: isAdmin() },
    // { path: '/addrole', content: <AddRole />, condition: isAdmin() },
    { path: "/task", content: <EnhancedTasks />, condition: isAdmin() },
    {
      path: "/addtask",
      content: <CreateEditTask isAddRoute />,
      condition: isAdmin(),
    },
    { path: "/edittask", content: <CreateEditTask />, condition: isAdmin() },
    // { path: '/taskmoderation', content: <TaskModerationOverview /> },
    // { path: '/translations', content: <Translations /> },
    // { path: '/translateTasks/:id?', content: <TranslateTasks /> },
    // { path: '/moderatetask', content: <ModerateTask /> },
    // { path: '/addtasktocollection', content: <AddTaskToCollection /> },
    { path: "/domain", content: <EnhancedDomain />, condition: isAdmin() },
    { path: "/difficultygroup", content: <DifficultyGroup /> },
    {
      path: "/teambasedstudents",
      content: <TeamBasedStudents />,
      condition: isAdmin(),
    },
    {
      path: "/competitions",
      content: <Competitions />,
      condition: isAdminOrPartnerOrAssistant(),
    },
    {
      path: "/teambasedmembers",
      content: <TeamBasedMembers />,
      condition: isAdmin(),
    },
    {
      path: "/teamcompetitions",
      content: <TeamCompetitions />,
      condition: isAdmin(),
    },
    {
      path: "/addcompetition",
      content: <AddCompetition />,
      condition: isAdmin(),
    },
    {
      path: "/editcompetition",
      content: <EditCompetition />,
      condition: isAdminOrPartner(),
    },
    {
      path: "/viewcompetition",
      content: <CompetitionDetails />,
      condition: isAssistant(),
    },
    { path: "/markingpreparation", content: <MarkingPreparation /> },
    { path: "/markingoverview", content: <MarkingOverview /> },
    { path: "/EditRoundMarking", content: <EditRoundMarking /> },
    { path: "/identifyUniqueAnswers", content: <IdentifyUniqueAnswers /> },
    { path: "/uploadStudentAnswer", content: <UploadStudentAnswer /> },
    // { path: '/pendingcompetitionpartners', content: <PendingCompetitionPartners />, condition: isAdmin() },
    // { path: '/assignDifficulty/:competitionID/:roundIndex/:levelIndex/:collectionID', content: <AssignDifficulty /> },
    {
      path: "/configureteamcompetition",
      content: <ConfigureTeamCompetition />,
      condition: isAdminOrPartner(),
    },
    {
      path: "/uploadteamcompetitionstudentanswer",
      content: <UploadTeamCompetitionStudentAnswer />,
    },
    {
      path: "/configureteamcompetitionmembers",
      content: <ConfigureTeamCompetitionMembers />,
      condition: isAdminOrPartner(),
    },
    {
      path: "/assignDifficulty",
      content: <AssignDifficulty />,
      condition: isAdmin(),
    },
    {
      path: "/indevidalStudent",
      content: <Indvedual particiapnt={partcipient} />,
    },
    { path: "/tasks", content: <TasksModeration></TasksModeration> },
    {
      path: "/collections",
      content: <CollectionsModeration></CollectionsModeration>,
    },
    { path: "/competition", content: <Comp></Comp> },
    { path: "/compReport", content: <EnhancedCompReport /> },
    { path: "/awardsStats", content: <AwardStats /> },
    { path: "/compCollections", content: <CompCollections /> },
    { path: "/verfiyassign", content: <VerfiyAssign /> },
    { path: "/cheatinglist", content: <CheatingList /> },
    { path: "/generalanswers", content: <GeneralAnswers /> },
    { path: "/awardsStats", content: <AwardStats /> },
    { path: "/editParticpantsBulk", content: <EditParticpantsBulk /> },
    {
      path: "/moderateTeamBased",
      content: <ModerateTeamBasedCompetitions />,
      condition: isAdmin(),
    },
    {
      path: "/champions",
      content: <ChampionsPage />,
      condition: isAdmin(),
    },
    {
      path: "/champions",
      content: <ChampionsPage />,
      condition: isAdmin(),
    },
    {
      path: "/configurecertificate",
      content: <ConfigureCertificate />,
    },
    {
      path: "/certificatetemplates",
      content: <ConfigureCertificate />,
    },
    {
      path: "/printcertificate",
      content: <PrintCertificate />,
      // condition: isAdmin(),
    },
    {
      path: "/assigntranslation",
      content: <AssignTranslation />,
      condition: isAdmin(),
    },
    {
      path: "/translate",
      content: <TranslationModulePlaceholder />,
    },
    {
      path: "/downloadcontestpaper",
      content: <DownloadContestPaper />,
      condition: isAdminOrPartner(),
    },
    {
      path: "/uploadedparticipantsfiles",
      content: <UploadedParticipantsFiles />,
      // condition: isAdminOrPartnerOrAssistant(),
    },
    {
      path: "/awardsCriteria",
      content: <AwardsCertiria />,
      condition: isAdmin(),
    },
    { path: "", content: <Error404 /> },
  ];
  const contentContainerStyle = {
    paddingTop: isLoggedIn() && 64,
    paddingBottom: isDashboardRoute ? 0 : 48,
    // borderRadius: '0 0 0 8px', backgroundColor: '#FFF'
    // display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '93.4vh'
  };
  return (
    <Box style={{ display: "flex" }}>
      {isLoggedIn() && (
        <SideBar
          open={open}
          toggleDrawer={toggleDrawer}
          hoverDrawer={hoverDrawer}
          unhoverDrawer={unhoverDrawer}
        />
      )}
      <Grid container style={contentContainerStyle}>
        {/* Content of the web app */}
        <Switch>
          {routes.map(
            ({ path, content, exact, defaultContent, condition }, i) => (
              <EveryLink
                key={i}
                path={path}
                content={content}
                exact={exact}
                defaultContent={defaultContent}
                condition={condition === undefined ? true : condition}
              />
            )
          )}
        </Switch>
      </Grid>
    </Box>
  );
};
export default function App() {
  const [open, setOpen] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const roleOptions = useSelector((state) => state.roleOptions);
  const countryOptions = useSelector((state) => state.countryOptions);
  const languageOptions = useSelector((state) => state.languageOptions);
  const dispatch = useDispatch();
  const toggleDrawer = (state) => {
    setOpen(state);
    setForceOpen(state);
  };
  const hoverDrawer = () => !forceOpen && setOpen(true);
  const unhoverDrawer = () => !forceOpen && setOpen(false);
  const populateCountryOptions = useCallback(() => {
    getCountries()
      .then((d) => dispatch(setCountryOptions(d)))
      .catch((e) => console.log(e));
  }, [dispatch]);
  const populateRoleOptions = useCallback(() => {
    getRoles()
      .then((d) => dispatch(setRoleOptions(d)))
      .catch((e) => console.log(e));
  }, [dispatch]);
  const populateLanguageOptions = useCallback(() => {
    getLanguages()
      .then((d) => dispatch(setLanguageOptions(d)))
      .catch((e) => console.log(e));
  }, [dispatch]);
  const roleOptionsLength = useMemo(() => roleOptions.length, [roleOptions]);
  const countryOptionsLength = useMemo(
    () => countryOptions.length,
    [countryOptions]
  );
  const languageOptionsLength = useMemo(
    () => languageOptions.length,
    [languageOptions]
  );

  useEffect(() => {
    if (
      isLoggedIn() &&
      !isTeacher() &&
      !roleOptionsLength &&
      !countryOptionsLength &&
      !languageOptionsLength
    ) {
      populateCountryOptions();
      populateRoleOptions();
      populateLanguageOptions();
    }
  }, [
    user,
    roleOptionsLength,
    countryOptionsLength,
    languageOptionsLength,
    populateRoleOptions,
    populateCountryOptions,
    populateLanguageOptions,
  ]);
  const boxStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "100vh",
  };
  return (
    <SnackbarProvider maxSnack={4}>
      <Router>
        <Box style={boxStyle}>
          <CssBaseline />
          {/* NavBar({ open, toggleDrawer }) */}
          {isLoggedIn() && <NavBar open={open} toggleDrawer={toggleDrawer} />}
          {/* {BodyContent({ open, toggleDrawer, hoverDrawer, unhoverDrawer })} */}
          <BodyContent
            open={open}
            toggleDrawer={toggleDrawer}
            hoverDrawer={hoverDrawer}
            unhoverDrawer={unhoverDrawer}
          />
          {/* <div style={{ border: '1px solid red', paddingLeft: 400 }}>{JSON.stringify({ roleOptionsLength, countryOptionsLength, languageOptionsLength })}</div> */}
          <Copyright open={open} />
        </Box>
      </Router>
    </SnackbarProvider>
  );
}
